import React, { createContext, useEffect, useState } from "react";
import Home from "../../Templates/Home/Home";
import { userContext } from "../../Contexts/userContext";
import { userInfo } from "../../Hooks/URL";
import useFetchWhen from "../../Hooks/useFetchWhen";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();
  const [contextData, setContextData] = useState({
    page: "",
    role: "",
    data: "",
    link: "",
    user: "",
  });

  const { data: userData } = useFetchWhen(userInfo, !contextData.user);

  useEffect(() => {
    if (userData) {
      setContextData({
        ...contextData,
        user: userData?.data?.name,
        role: userData?.data?.role,
      });
    }

    if (userData?.data?.role == "teacher" && document.location.pathname == "/")
      navigate("/classes");
  }, [userData]);

  return (
    <userContext.Provider value={{ contextData, setContextData }}>
      <Home />
    </userContext.Provider>
  );
}

export default HomePage;
